/* eslint-disable camelcase */
import Axios from 'axios'
import globalConfig from '../config'

export const userService = {
  getAllUsers: async () => {
    const { data } = await Axios.get(`${globalConfig.url}/api/usuarios`)
    return data
  },
  getOneUser: async (id) => {
    const { data } = await Axios.get(`${globalConfig.url}/api/usuarios/${id}`)
    return data
  },
  createOneUser: async (user) => {
    const { data } = await Axios.post(`${globalConfig.url}/api/usuarios`, user)
    return data
  },
  updateOneUser: async (uid, user) => {
    console.log('ID_USER', uid)
    const { data } = await Axios.put(`${globalConfig.url}/api/usuarios/${uid}`, user)
    return data
  },
  startOrganizerOnboarding: async (uid, user) => {
    const { data } = await Axios.put(`${globalConfig.url}/api/usuarios/organizer/onboarding/${uid}`, user)
    return data
  },
  continueOrganizerOnboarding: async (uid) => {
    const { data } = await Axios.get(`${globalConfig.url}/api/usuarios/organizer/onboarding/continue/${uid}`)
    return data
  },
  deleteOneUser: async (id) => {
    const { data } = await Axios.delete(`${globalConfig.url}/api/usuarios/${id}`)
    return data
  },
  verifyStripeConnectOnboarding: async (uid) => {
    const { data } = await Axios.get(`${globalConfig.url}/api/usuarios/organizer/onboarding/${uid}`)
    return data
  },
  getAllPublicationsAproved: async () => {
    const { data } = await Axios.get(`${globalConfig.url}/api/usuarios/publicaciones/aprobadas`)
    return data
  },
  getAllStats: async (idEvento) => {
    console.log(idEvento)
    const { data } = await Axios.get(`${globalConfig.url}/api/usuarios/estadisticas/${idEvento}`)
    return data
  },
  getAllStatsEvent: async (idEventoTotal) => {
    console.log(idEventoTotal)
    const { data } = await Axios.get(`${globalConfig.url}/api/usuarios/estadisticas/total/${idEventoTotal}`)
    return data
  }
}
